var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('ServiceSubheader'),_c('p',[_vm._v("Reports")]),_c('TipManagementReportsComponent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }